import type { SessionInfoDTO } from './dto-client'
import { AccountVerificationStatus, MembershipStatus, TwoFAStatus } from './dto-client'

const isExistingMembership = (d: SessionInfoDTO): boolean =>
    d.membershipStatus !== MembershipStatus.NOT_SUBMITTED &&
    d.membershipStatus !== MembershipStatus.RESTARTED

/**
 * Derived predicates for session info. Pure functions over the SessionInfoDTO —
 * previously getters on the (now removed) SessionInfo model class.
 */
export const sessionInfoSelectors = {
    isReturningCustomer: (d: SessionInfoDTO): boolean => d.preQualifiedSuccessCount > 1,
    isVerified: (d: SessionInfoDTO): boolean =>
        d.accountVerificationStatus === AccountVerificationStatus.VERIFIED,
    shouldShowKYC: (d: SessionInfoDTO): boolean =>
        d.accountVerificationStatus !== AccountVerificationStatus.VERIFIED &&
        d.accountVerificationStatus !== AccountVerificationStatus.PENDING,
    isFirstTimeShopper: (d: SessionInfoDTO): boolean =>
        d.membershipStatus === MembershipStatus.NOT_SUBMITTED ||
        d.membershipStatus === MembershipStatus.RESTARTED,
    isVerificationExpired: (d: SessionInfoDTO): boolean =>
        d.accountVerificationStatus === AccountVerificationStatus.EXPIRED,
    isExistingMembership,
    // The signature endpoints reject a customer without a PIN (TWO_FA_IS_NOT_SET), and an
    // in-store verification can create a membership without one.
    isExistingMemberWithoutTwoFaPin: (d: SessionInfoDTO): boolean =>
        isExistingMembership(d) && d.twoFAStatus === TwoFAStatus.NOT_SET,
}
